import { render, staticRenderFns } from "./project_nijian.vue?vue&type=template&id=90fdedc0&"
import script from "./project_nijian.vue?vue&type=script&lang=js&"
export * from "./project_nijian.vue?vue&type=script&lang=js&"
import style0 from "./project_nijian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports